var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Progress } from 'reactstrap';
import { Modal } from '@app/Components/Modal/Modal';
import { colorThemesStore } from '@app/Stores/ColorThemesStore';
import styles from './DocumentsDownloadProgressModal.module.scss';
export var DocumentsDownloadProgressModal = /** @class */ (function (_super) {
    __extends(DocumentsDownloadProgressModal, _super);
    function DocumentsDownloadProgressModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentsDownloadProgressModal.prototype._getStatus = function () {
        var _a;
        var isDownloadFinished = (_a = this.props, _a.isDownloadFinished), isDownloadFailed = _a.isDownloadFailed, progress = _a.progress;
        if (isDownloadFailed) {
            var isEveryFileFailed = !!(progress === null || progress === void 0 ? void 0 : progress.total) && progress.failedFileNames.length === progress.total;
            return isEveryFileFailed
                ? 'None of the found documents could be downloaded, the archive was not created'
                : 'The archive was interrupted and has not been saved, please try again';
        }
        return isDownloadFinished ? 'Archive is ready' : 'Preparing archive, you can close this window';
    };
    DocumentsDownloadProgressModal.prototype._getBarColor = function () {
        var _a, _b;
        var isDownloadFinished = (_a = this.props, _a.isDownloadFinished), isDownloadFailed = _a.isDownloadFailed;
        var red = (_b = colorThemesStore.appColors, _b.red), green = _b.green;
        if (isDownloadFailed)
            return red;
        return isDownloadFinished ? green : undefined;
    };
    DocumentsDownloadProgressModal.prototype.render = function () {
        var _a;
        var isOpen = (_a = this.props, _a.isOpen), isDownloadFailed = _a.isDownloadFailed, progress = _a.progress, toggle = _a.toggle;
        var processed = (progress === null || progress === void 0 ? void 0 : progress.processed) || 0;
        var total = (progress === null || progress === void 0 ? void 0 : progress.total) || 0;
        var failedFileNames = (progress === null || progress === void 0 ? void 0 : progress.failedFileNames) || [];
        var red = colorThemesStore.appColors.red;
        return (React.createElement(Modal, { isOpen: isOpen, toggle: toggle, headerTitle: "Documents Download", minWidth: "500px", footerbuttons: [{ title: 'Close', onClick: toggle }] },
            React.createElement("div", { className: styles.status, style: { color: isDownloadFailed ? red : undefined } }, this._getStatus()),
            React.createElement("div", { className: styles.counter },
                processed,
                " of ",
                total,
                " file(s) processed"),
            React.createElement(Progress, { value: processed, max: total || 1, barStyle: { backgroundColor: this._getBarColor() } }),
            !!failedFileNames.length && (React.createElement("div", { className: styles.failed },
                React.createElement("div", { className: styles.failedTitle, style: { color: red } },
                    failedFileNames.length,
                    " file(s) could not be downloaded and were skipped:"),
                React.createElement("ul", { className: styles.failedList }, failedFileNames.map(function (fileName) { return (React.createElement("li", { key: fileName }, fileName)); }))))));
    };
    DocumentsDownloadProgressModal = __decorate([
        observer
    ], DocumentsDownloadProgressModal);
    return DocumentsDownloadProgressModal;
}(React.PureComponent));
